var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-logo"},[_c('div',{staticClass:"app-title"},[_vm._v(_vm._s(_vm.currentDistributorName))])])}
var staticRenderFns = []

export { render, staticRenderFns }